module.exports = __webpack_public_path__ + "static/media/Homecentre_Watermark_Threekit.0a5bc6cd.png";